<template>
  <div class="car-item-component">
    <div class="row car-item-header">
      <div class="col-xs-6">
        <router-link class="btn-xs btn btn-default" :to="'/fleet/vehicles/edit/' + car.uuid">
          <span class="fa fa-edit fa-fw"></span> Edit
        </router-link>
      </div>
      <div class="col-xs-6 text-right">
        <span class="badge" :class="randomLabel(car.CarType.CarClass.name)">{{ car.CarType.CarClass.name }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <org-logo v-if="car.Organization" :org="car.Organization"></org-logo>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <img class="img-thumbnail" :src="'https://techcar-dev.s3.amazonaws.com/'+ ( car.CarType.AmazonImage.objectKey ? car.CarType.AmazonImage.objectKey : 'spacer.gif' ) + '?v=' + new Date().getTime()"/>
      </div>
      <div class="col-sm-6">
        <span class="car-name">
          <router-link :to="{ path: `/fleet/vehicles/${car.uuid}` }">{{ car.dropdownLabel }}</router-link>
        </span>
        <template v-if="car.Lot.premiumAmount > 0">
          <p><strong>{{ car.Lot.premiumAmount | to_dollar_amount }} Premium</strong><br>
            {{ car.Lot.premiumReason }}
          </p>
        </template>
        <template v-if="car.CarHardware">
          <p>
            <strong>Hardware:</strong><br/>
            <span class="fa fa-power-off"></span> {{ car.CarHardware.provider }}
          </p>
        </template>
        <p><strong>Features</strong><br/>
          <template v-for="feature in car.CarFeatures">
            <i v-if="feature.icon" class="fa-lg" :class="[
              feature.icon,
              {
                'fab': feature.icon === 'fa-bluetooth',
                'fa': feature.icon !== 'fa-bluetooth'
              }
            ]" :key="feature.uuid"></i> {{ feature.name }}
          </template>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <h4>Contract Details</h4>
        <p><strong>Contract Term:</strong> {{ car.contractTerm || 0 }} months</p>
        <p><strong>Monthly Payment:</strong> {{ car.monthlyContractCost | to_dollar_amount }}</p>
        <p><strong>Permitted KM:</strong> {{ car.contractPermittedKm || 0 }}km</p>

        <h4>Usage Summary</h4>
        <template v-for="(data, year) in usage">
          <div class="form-section" :key="year">
            <h4>{{ year }}</h4>
            <p><strong>Total Reservations:</strong> {{ data[car.uuid].reservations }}<br/>
            <strong>Total KM Usage:</strong> {{ data[car.uuid].km | pretty_number }} km</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OrgLogo from '@/components/OrgLogo'
import { randomLabel } from '@/util/helpers'
import moment from 'moment-timezone'
export default {
  name: 'ContractCarItem',
  components: {
    OrgLogo
  },
  props: {
    object: {
      type: Object
    },
    usage: {
      type: Object
    }
  },
  computed: {
    car () {
      return {
        CarType: {
          CarClass: {}
        },
        Organization: false,
        ...this.object
      }
    },
    lotInformation () {
      // default lot
      let lot = this.car.Lot
      let relocationEndTime = false
      // loop through pending relocations
      for (let relocation in this.car.LotRelocations) {
        // if the relocation is permanent
        if (relocation.permanent) {
          // if the booking is after the relocation
          if (moment(relocation.endDate).isBefore(this.start)) {
            // if there is a previously found relocation and its before the
            // found relocation OR if there is no previously found relocation
            if ((relocationEndTime && moment(relocationEndTime).isBefore(relocation.endDate)) || !relocationEndTime) {
              lot = relocation.Lot
              relocationEndTime = relocation.endDate
            }
          }
        } else {
          // temporary relocations
          // if the booking times are between the relocation
          if (moment(this.start).isBetween(relocation.startDate, relocation.endDate) &&
            moment(this.end).isBetween(relocation.startDate, relocation.endDate)) {
            lot = relocation.Lot
          }
        }
      }
      return lot
    }
  },
  methods: {
    randomLabel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/ContractCarItem.vue